<script setup>
  defineOptions({
    name: "ComponentScanQrCodeIcon",
  });
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="144"
    height="96"
    viewBox="0 24 96 48"
    fill="none"
    :data-test="getTestId('icon-svg-scan-qr-code')"
  >
    <mask
      id="scan-qr-code-icon-a"
      width="59"
      height="60"
      x="-2"
      y="18"
      maskUnits="userSpaceOnUse"
      style="mask-type: alpha"
    >
      <path fill="#D9D9D9" d="M-2 18.506h58.988v58.988H-2z" />
    </mask>
    <g mask="url(#scan-qr-code-icon-a)">
      <path
        fill="#1C1B1F"
        d="M2.92 65.867q-1 0-1.73-.758a2.5 2.5 0 0 1-.732-1.795h8.333q-1.416 0-2.41-.993-.993-.993-.993-2.41v-28.17q0-1.417.993-2.41.994-.994 2.41-.994h37.406q1.417 0 2.41.993.994.994.993 2.41v28.171q0 1.416-.992 2.41-.994.993-2.411.993h8.333a2.44 2.44 0 0 1-.757 1.808 2.47 2.47 0 0 1-1.795.745zm24.574-.738q.605 0 .968-.364.365-.365.365-.945t-.365-.969-.968-.388q-.603 0-.968.395a1.34 1.34 0 0 0-.365.939q0 .603.365.968.365.364.968.364M8.791 61.423h37.406q.567 0 1.04-.472.473-.473.473-1.04v-28.17q0-.568-.473-1.04t-1.04-.473H8.791q-.567 0-1.04.473-.473.472-.473 1.04v28.17q0 .567.473 1.04.473.472 1.04.472"
      />
    </g>
    <mask
      id="scan-qr-code-icon-b"
      width="31"
      height="31"
      x="12"
      y="30"
      maskUnits="userSpaceOnUse"
      style="mask-type: alpha"
    >
      <path fill="#D9D9D9" d="M12.747 30.795h29.494v29.494H12.747z" />
    </mask>
    <g mask="url(#scan-qr-code-icon-b)">
      <path
        fill="#1C1B1F"
        d="M28.723 55.42V53.2h2.221v2.22zM26.5 53.2v-5.436h2.222v5.435zm8.65-4.16v-3.498h2.221v3.498zm-2.222-3.498v-2.221h2.222v2.221zm-13.092 2.222v-2.222h2.221v2.222zm-2.222-2.222v-2.221h2.222v2.221zm9.879-7.657v-2.221h2.221v2.221zm-8.933 3.498h4.774v-4.774H18.56zm-.946.945v-6.665h6.665v6.665zm.946 12.147h4.963v-4.774H18.56zm-.946.946v-6.665h6.854v6.665zm14.038-14.038h4.774v-4.774h-4.774zm-.945.945v-6.665h6.665v6.665zM32.93 55.42v-4.16h-2.22V49.04h4.442v4.16h2.221v2.22zm-4.206-7.657v-2.222h4.206v2.222zm-4.443 0v-2.222h-2.222v-2.221h6.665v2.221H26.5v2.222zm.992-5.436v-4.443h2.222v2.222h2.221v2.22zm-5.104-2.552v-1.56h1.56v1.56zm.165 12.927v-1.56h1.56v1.56zM33.26 39.776v-1.56h1.56v1.56z"
      />
    </g>
    <mask
      id="scan-qr-code-icon-c"
      width="54"
      height="54"
      x="46"
      y="22"
      maskUnits="userSpaceOnUse"
      style="mask-type: alpha"
    >
      <path fill="#D9D9D9" d="M100 22.193H46.542V75.65H100z" />
    </mask>
    <g mask="url(#scan-qr-code-icon-c)">
      <path
        fill="#1C1B1F"
        d="M73.434 70.297q.305 0 .651-.063.348-.062.651-.173l11.733-4.413a3.87 3.87 0 0 0 1.773-1.406 3.6 3.6 0 0 0 .651-2.072q0-.15-.235-1.259l-5.882-16.53h2.772l-4.832-7.183a1.41 1.41 0 0 1-.259-1.11q.104-.604.512-1.01l.351-.352 8.434 7.316a6 6 0 0 1 1.527 2.037 5.9 5.9 0 0 1 .538 2.483v11.484h2.013V46.562q0-1.735-.722-3.318a8 8 0 0 0-2.04-2.735l-9.874-8.55-2.086 2.13-1.024-2.862q-.416-1.166-1.385-1.823a3.7 3.7 0 0 0-2.106-.658q-.316 0-.679.078a4.3 4.3 0 0 0-.68.2l-11.732 4.413q-1.12.458-1.751 1.414a3.7 3.7 0 0 0-.63 2.077q0 .377.235 1.246l1.496 4.25q-1.745.106-2.78 1.203-1.037 1.097-1.037 2.467 0 .45.114.879.113.428.353.835h-1.11q-1.538 0-2.61 1.073-1.074 1.073-1.073 2.61 0 1.294.76 2.202a4.5 4.5 0 0 0 1.917 1.337 2.7 2.7 0 0 0-.388.923q-.105.491-.105.936 0 1.538 1.052 2.61 1.05 1.074 2.589 1.074h1.153q-.24.363-.375.835-.136.471-.136.878 0 1.539 1.074 2.61 1.073 1.074 2.61 1.074H69.3l.63 1.89q.403 1.176 1.364 1.807.963.63 2.14.63m-2.587-5.077-9.098-25.482 15.377-5.791 9.099 25.482zM68.602 64h-5.74a1.65 1.65 0 0 1-1.208-.506 1.65 1.65 0 0 1-.505-1.208q0-.702.505-1.208a1.65 1.65 0 0 1 1.209-.505h4.476zm-1.919-5.397h-8.147q-.703 0-1.186-.506a1.69 1.69 0 0 1-.485-1.208q0-.702.485-1.208a1.58 1.58 0 0 1 1.186-.505h6.84zm-1.962-5.398h-8.327a1.65 1.65 0 0 1-1.207-.505 1.65 1.65 0 0 1-.506-1.208q0-.703.506-1.208.506-.506 1.207-.506h7.12zm-1.961-5.397H60.72a1.65 1.65 0 0 1-1.208-.506 1.65 1.65 0 0 1-.505-1.208q0-.702.505-1.207a1.65 1.65 0 0 1 1.208-.506h.83z"
      />
    </g>
    <mask
      id="scan-qr-code-icon-d"
      width="27"
      height="27"
      x="61"
      y="36"
      maskUnits="userSpaceOnUse"
      style="mask-type: alpha"
    >
      <path fill="#D9D9D9" d="m61.29 43.877 18.855-6.937 6.936 18.856-18.855 6.936z" />
    </mask>
    <g mask="url(#scan-qr-code-icon-d)">
      <path
        fill="#1C1B1F"
        d="M73.998 51.62a2.32 2.32 0 0 0 1.352-1.243q.42-.9.075-1.833a2.32 2.32 0 0 0-1.243-1.353 2.3 2.3 0 0 0-1.834-.075 2.32 2.32 0 0 0-1.353 1.243q-.418.9-.075 1.834.345.934 1.244 1.353t1.834.075m4.748.686-2.965-1.383q-.29.453-.682.788t-.866.51q-1.2.44-2.339-.085a2.94 2.94 0 0 1-1.577-1.717 2.93 2.93 0 0 1 .089-2.33q.525-1.138 1.716-1.576a2.94 2.94 0 0 1 2.33.088q1.138.526 1.58 1.726.174.473.171.99a3.6 3.6 0 0 1-.16 1.032l2.98 1.364zM71.3 58.034q-.452.166-.887-.034a1.12 1.12 0 0 1-.6-.654l-1.021-2.774.604-.223 1.02 2.775q.067.18.274.276a.5.5 0 0 0 .388.03l2.774-1.021.222.604zm7.621-2.804-.222-.604 2.774-1.021a.5.5 0 0 0 .277-.273.5.5 0 0 0 .029-.388l-1.021-2.775.604-.222 1.021 2.774q.167.453-.034.888-.201.434-.654.6zM67.01 49.725l-1.02-2.774q-.167-.453.033-.887.201-.435.654-.601l2.774-1.02.222.604-2.774 1.02a.5.5 0 0 0-.277.274.5.5 0 0 0-.029.388l1.021 2.774zm11.966-4.402-1.02-2.774a.5.5 0 0 0-.274-.277.5.5 0 0 0-.388-.029l-2.774 1.02-.222-.604 2.774-1.02q.453-.167.887.034.435.2.6.653L79.58 45.1z"
      />
    </g>
  </svg>
</template>
